<div class="container">
    <h2>{{ authService.user.name }} Portal</h2>
    <app-dash-client></app-dash-client>
</div>
